import { ClassData } from '@models/class-data';
import { Currency, CurrencySymbols } from '@utils/currency';

export class TicketPaymentOptions {
  id: number;
  createdAt?: Date;
  currency: Currency;
  country?: string;

  transactionFeePaidByGuest: boolean;

  constructor(json: ClassData<TicketPaymentOptions>) {
    this.id = +json.id;
    if (json.createdAt) {
      this.createdAt = new Date(json.createdAt);
    }
    this.currency = json.currency;
    this.country = json.country;

    this.transactionFeePaidByGuest = json.transactionFeePaidByGuest;
  }

  getCurrencySymbol() {
    let currencySymbol = '€';
    if (this.currency) {
      currencySymbol = CurrencySymbols[this.currency];
    }

    return currencySymbol;
  }

  getCurrency(): Currency {
    if (!Object.values(Currency).includes(this.currency as Currency)) {
      return Currency.EUR;
    }

    return this.currency;
  }
}
